import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const VehicleRegistration = ({price}) => {
  const { t } = useTranslation('common')

  return (
    <div className='oglasi-cijena-registracije'>
      <div className='oglasi-cijena-registracije-header'>
        <i className='ico-tab-specifikacija ico' />
        <p>{t('Cijena registracije')}</p>
      </div>
      <div className='oglasi-cijena-registracije-content'>
        <p>{t('cijena-registracije-tekst')}&nbsp;
          <span className='registracija-info-cijena'>{price} &euro;</span>
        </p>
      </div>
    </div>
  )
}

VehicleRegistration.propTypes = {
  price: PropTypes.number.isRequired
}
